import { Injectable } from '@angular/core';

declare var window: any; // Para evitar errores con `window.dataLayer`
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  constructor(private router: Router) {}

  /**
   * Enviar evento a Google Tag Manager
   * @param eventName Nombre del evento (Ej: 'page_view', 'add_to_cart', etc.)
   * @param eventData Datos adicionales del evento
   */
  public sendEvent(eventName: string, eventData: any = {}, isEcommerce: boolean = true): void {
    // console.log('eventName',eventName, 'eventData', eventData);
    if (window && window.dataLayer) {
      // window.dataLayer.push({
      //   event: eventName,
      //   ecommerce: eventData
      // });
        const dlEvent = isEcommerce
          ? { event: eventName, ecommerce: eventData }
          : { event: eventName, ...eventData };

        window.dataLayer.push(dlEvent);
      // console.log(`✅ GTM Event: ${eventName}`, eventData);
    } else {
      // console.warn('⚠️ Google Tag Manager no está disponible.');
    }



     // Enviar directamente a GA4 usando gtag()
      if (typeof (window as any).gtag === 'function') {
        (window as any).gtag('event', eventName, eventData);
        // console.log(`✅ GA4 Event: ${eventName}`, eventData);
      } else {
        // console.warn('⚠️ gtag no está disponible.');
      }

  }

  /**
   * Registrar una vista de página en GTM
   */
  trackPageView(url: string) {
    this.sendEvent('page_view', { page_path: url });
  }

  initializeTracking() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.trackPageView(event.urlAfterRedirects);
      }
    });
  }

  /**
   * Evento de agregar al carrito
   */
  public addToCart(productId: string, name: string, price: number, quantity: number = 1, variante:string): void {
    this.sendEvent('add_to_cart', {
      // ecommerce: {
        items: [
          {
            item_id: productId,
            item_name: name,
            price: price,
            quantity: quantity,
            variante: variante
          }
        ]
      // }
    });
  }

  /**
   * Evento de eliminar del carrito
   */
  public removeFromCart(productId: string, name: string, price: number, quantity: number = 1, variante:string): void {
    this.sendEvent('remove_from_cart', {
      // ecommerce: {
        items: [
          {
            item_id: productId,
            item_name: name,
            price: price,
            quantity: quantity,
            variante: variante
          }
        ]
      // }
    });
  }

  /**
   * Evento de inicio de checkout
   */
  public beginCheckout(items: any[]): void {
    this.sendEvent('begin_checkout', {
      // ecommerce: {
        items: items
      // }
    });
  }

  /**
   * Evento de visualización de lista de productos
   */
  public viewItemList(itemListName: string, items: any[]): void {
    this.sendEvent('view_item_list', {
      // ecommerce: {
        item_list_name: itemListName,
        items: items
      // }
    });
  }

  /**
   * Evento de visualización de un producto en detalle
   */
  public viewItem(productId: string, name: string, price: number): void {
    this.sendEvent('view_item', {
      // ecommerce: {
        items: [
          {
            item_id: productId,
            item_name: name,
            price: price
          }
        ]
      // }
    });
  }

  /**
   * Evento de compra
   */
  public purchase(transactionId: string, total: number, items: any[]): void {
    this.sendEvent('purchase', {
      // ecommerce: {
        transaction_id: transactionId,
        value: total,
        currency: 'USD',
        items: items
      // }
    });
  }


    /**
   * Evento de completar pasos del formulario
   */
  public formStep(key: string, name: string): void {
    this.sendEvent('form_step', {
        step_key: key, //'delivery_address',
        step_name: name//'Dirección de entrega'
      });
  }
  /**
   * Evento volver atrás en el formulario
   */
  public formStepBack(from_step: string, to_step: string): void {
    this.sendEvent('form_step_back', {
      from_step,//: delivery_information,
      to_step,//: personal_information,
    });
  }

/**
   * Evento seleccion de delivery
   */
  public formDeliverySelected(service): void {
    this.sendEvent('form_delivery_option', service);
  }



}



